const push = (relativePath: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (relativePath?.[0] && relativePath[0] === '/') {
    window.location.href = `${window.location.origin}${relativePath}`;

    return;
  }

  window.location.href = `${window.location.origin}/${relativePath}`;
};

const routingUtils = {
  push,
};

export default routingUtils;
